import { IGetCentroCustoUseCase } from "../../../presentation/useCases/read/get_centro_custo_incorporacao_use_case";
import { CentroCusto } from "../../models/centro_custo";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * GetAllCentroCustoUseCase
 */

export class GetCentroCustoUseCase implements IGetCentroCustoUseCase {
    constructor(private readonly repository: IComercialRepository) { }

    async getCentroCustoByid(
        idCentroCusto: number
    ): Promise<CentroCusto> {
        const response = await this.repository.getCentroCustoById(idCentroCusto);
        return response;
    };



}
